
import { defineComponent } from "vue";
import {
  getHumanDateDiff,
  getHumanDate,
  getHumanDateOffset,
} from "../util/luxonDateHelpers";
import ReceiverStatsDisplayCard from "./ReceiverStatsDisplayCard.vue";

export default defineComponent({
  name: "ReceiverStatsDisplay",
  components: {
      ReceiverStatsDisplayCard
  },
  methods: {
    getHumanDateDiff,
    getHumanDate,
    getHumanDateOffset
  },
  props: [
      'receiverStats'
  ]
})
